export default "__VITE_ASSET__adb8fa88__"